export default __webpack_public_path__ + "static/RobotoMono-Regular-9e4eb2ecfb9c66e41ba6438cddaf7829.ttf";